module.exports = __webpack_public_path__ + "media/images/icon_list/info-46d7cc105f71bc640079c42d88ea63ee.svg";